/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkNDCAndAddToDetailsTable,
  setNDCErrorPopupMessage,
} from '../../store/action';
import MoveToDetailsIconContainer from '../MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import NDCViewDetailsTable from '../NDCViewDetailsTable/NDCViewDetailsTable';
import SearchComponent from './SearchComponent';
import TableComponent from './TableComponent';

const NDCByDrugName = ({
  fullScreen,
  setFullScreen,
  isViewNDCHidden,
  setErrorMessages,
}) => {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState([]);

  const searchByDrugNameTableData = useSelector(
    (state) => state.sharedState.ndc.searchByDrugNameTableData
  );

  const [gridApi, setGridApi] = useState(null);

  const addSingleRowToDetailsTable = () => {
    if (selectedRow.length === 0) {
      dispatch(setNDCErrorPopupMessage('Please select from the drug names'));
    } else {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(checkNDCAndAddToDetailsTable(selectedRow));
      gridApi.deselectAll();
    }
  };

  const addAllToDetailsTable = () => {
    if (searchByDrugNameTableData.length == 0) {
      dispatch(setNDCErrorPopupMessage('NDC not found'));
    } else {
      dispatch(setNDCErrorPopupMessage(null));
      dispatch(checkNDCAndAddToDetailsTable(searchByDrugNameTableData));
      gridApi.deselectAll();
    }
  };
  const [gridDisplayMatrix, setGridDisplayMatrix] = useState({
    LTGridDisplay: true,
    grid1Display: true,
    grid2Display: true,
  });
  useEffect(() => {
    if (fullScreen == false) {
      setGridDisplayMatrix({
        LTGridDisplay: true,
        grid1Display: true,
        grid2Display: true,
      });
    }
  }, [fullScreen]);
  const handleFullScreenGird1 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleFullScreenGird2 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleLTGridFullScree = () => {
    setGridDisplayMatrix({
      LTGridDisplay: true,
      grid1Display: false,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  return (
    <div className='my-4 container mx-0'>
      <div className='row'>
        {gridDisplayMatrix.grid1Display ? (
          <div
            className={`${fullScreen ? 'col-12' : 'col-5'}  d-flex flex-column`}
          >
            {!fullScreen && <SearchComponent />}
            <TableComponent
              setSelectedRow={setSelectedRow}
              searchByDrugNameTableData={searchByDrugNameTableData}
              gridApi={gridApi}
              setGridApi={setGridApi}
              fullScreen={fullScreen}
              setFullScreen={handleFullScreenGird1}
            />
          </div>
        ) : null}
        {!fullScreen && (
          <>
            <div className='col-2 px-2'>
              <MoveToDetailsIconContainer
                handleSingleMove={() => addSingleRowToDetailsTable()}
                handleAllMove={() => addAllToDetailsTable()}
                handleRemove={() => {}}
              />
            </div>
          </>
        )}

        {gridDisplayMatrix.grid2Display ? (
          <div
            className={`${
              fullScreen ? 'col-12' : 'col-5'
            }  d-flex flex-column p-0`}
            style={{ marginTop: '16px' }}
          >
            <NDCViewDetailsTable
              isViewNDCHidden={isViewNDCHidden}
              fullScreen={fullScreen}
              setFullScreen={handleFullScreenGird2}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default NDCByDrugName;
